import React, {Suspense, ReactElement} from 'react';
//import ReactDOM from 'react-dom';

import ReactDOM from 'react-dom/client';

import axios from "axios";

import {ThreeDots} from "react-loader-spinner";

//import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import AdapterDateFns from '@mui/lab/AdapterDateFns';

//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

// import MUI.
import { createTheme, ThemeProvider } from '@mui/material/styles';


import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { SnackbarProvider } from 'notistack';

import { defaultConfig, globalConfig, globalConfigUrl} from './configuration/config';

import './library/i18n';

import {theme} from './theme';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      //refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      //staleTime: twentyFourHoursInMs,
    },
  },
});

const eHeliosApp: ReactElement = <ThemeProvider theme={theme}>
                            <SnackbarProvider maxSnack={3}>
                              <Suspense fallback={<ThreeDots color='#00BFFF' />}>
                                <QueryClientProvider client={queryClient}>
                                  <React.StrictMode>    
                                    <App />
                                  </React.StrictMode>
                                  <ReactQueryDevtools initialIsOpen={false} />
                                </QueryClientProvider>
                              </Suspense>
                            </SnackbarProvider>
                          </ThemeProvider>;

axios.get(globalConfigUrl).then((response) => {
      globalConfig.set(response.data);
      //console.log("Global config fetched: ",response.data);
      //log.debug("Global config fetched: ", response.data);
      return eHeliosApp;
  }).catch((e) => {
  // In Codesandbox.io: deleting `config.json` will not trigger this branch, because the request response code will still be 200, not 404.
  // To test this case in codesanbox.io, add "throw {};" to line 22.

  // In development, treat this case as a warning, render the app and use default config values.
  // In production (and test) on the other hand, show error instead of rendering the app.

  // In Codesandbox.io: You cannot change the value of NODE_ENV. To test this if, change "development"
  if (process.env.NODE_ENV === "development") {
    // You cannot change the value of NODE_ENV. To test this if, change "development"
    // log.warn(`Failed to load global configuration from '${globalConfigUrl}', using the default configuration instead:`,
    //   defaultConfig
    // );
    globalConfig.set(defaultConfig);
    return eHeliosApp;
  } else {
    const errorMessage = "Error while fetching global config, the App wil not be rendered. (This is NOT a React error.)";
    //log.error(errorMessage, `Have you provided the config file '${globalConfigUrl}'?`, e );
    return ( <p style={{ color: "red", textAlign: "center" }}>{errorMessage}</p> );
  }
})
.then((reactElement: ReactElement) => {
  const container = document.getElementById('root');
  const root = ReactDOM.createRoot(container!);

  root.render(reactElement);
  //ReactDOM.render(reactElement, document.getElementById("root"));
});

// ReactDOM.render(
//   <ThemeProvider theme={theme}>
//     <SnackbarProvider maxSnack={3}>
//       <Suspense fallback={<Loader type='ThreeDots' color='#00BFFF' />}>
//         <QueryClientProvider client={queryClient}>
//           <React.StrictMode>    
//             <App />
//           </React.StrictMode>
//           <ReactQueryDevtools initialIsOpen={false} />
//         </QueryClientProvider>
//       </Suspense>
//     </SnackbarProvider>
//   </ThemeProvider>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
